"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { trackMetaPageView, trackPageView } from "@/lib/analytics";

export default function PageviewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams?.toString();
  useEffect(() => {
    const url = search ? `${pathname}?${search}` : pathname;
    trackPageView(url);
    /* Every page, the first one included. This used to skip the first view on
       the assumption that the pixel snippet in app/layout.tsx sends it, but
       that fbq('track', 'PageView') was removed in March (dd536de), so no hard
       load, i.e. no ad landing page, ever reached Meta as a PageView. */
    trackMetaPageView();
  }, [pathname, search]);

  return null;
}
